import React, {Suspense} from 'react';
import {Switch} from 'react-router-dom';
import {AiReportsPage} from './components/AiReportsPage';
import {ContentRoute, LayoutSplashScreen} from '../../../_metronic/layout';

export default function AiReportsPageContainer() {
  return (
    <Suspense fallback={<LayoutSplashScreen/>}>
      <Switch>
        <ContentRoute path="/ai-reports" component={AiReportsPage}/>
      </Switch>
    </Suspense>
  );
}
